import React from 'react';
import { crossErrorIcn } from '../../images/btnIcons';

const ErrorDialogue = ({
    type = 'actionDialog',
    msg,
    actions = [],
    closeDialogue = () => {}
}) => {
    return (
        <div className="ppDialogue mergeChunkDialogBx">
            <div className="mergeChunkDialogBxContent">
                {type === 'error' && <div className='close_btn' onClick={closeDialogue}>
                    X
                </div>}
                <div className="mergeChunkDialogBxContentWrapper">
                    {type === 'error' && <p className="alrt-icn"><img src={crossErrorIcn} alt="alrt-icn" /></p>}
                    <p className="mergeChunkDialogText">{msg}</p>
                    <div className='alrtActionBtnCntnr'>
                    {actions.length > 0 && actions.map((action, index) => (
                        <button onClick={action.action} key={index} className={`mergeChunkDialogBtn ${action.className}`}>{action.actionText}</button>
                    ))}
                    </div>
                    {/* <button className="mergeChunkDialogBtn submit_button--generate_otp">Close</button> */}
                </div>
            </div>
        </div>
    );
};

export default ErrorDialogue;